import React, { useCallback } from "react";
import { Grid } from "@mui/material";
import { IconHierarchyFolded } from "@mzc-cloudplex/icons";
import Skeleton from "@components_v2/skeleton/skeleton";
import { Box } from "@mzc-pdc/ui";

const FolderTreeViewSkeleton = ({ classes, type, depth }) => {
    const skeletonItem = useCallback(
        (depth = 0) => (
            <Grid
                container
                flexDirection={"row"}
                alignItems={"center"}
                sx={{
                    minWidth: 318,
                    height: "38px",
                    paddingLeft: `${(depth + 1) * 16}px`,
                }}
            >
                <Grid item display={"flex"} alignItems={"center"} justifyContent={"center"} width={15} mr={0.5}>
                    <IconHierarchyFolded size={12} htmlColor={"#6f6f83"} />
                </Grid>
                <Grid item display={"flex"} alignItems={"center"}>
                    <Skeleton
                        variant={"rectangular"}
                        animation={"wave"}
                        height={20}
                        sx={{ width: `${depth === 0 ? "200px" : `${283 - depth * 16}px`}`, borderRadius: "3px" }}
                    />
                </Grid>
            </Grid>
        ),
        [],
    );

    return (
        <>
            {type === "root" ? (
                <>
                    {skeletonItem()}
                    {skeletonItem(1)}
                </>
            ) : (
                <>{skeletonItem(depth)}</>
            )}
        </>
    );
};

export default FolderTreeViewSkeleton;
